import React, { Component } from "react";
import { DropdownButton, MenuItem } from "react-bootstrap";
import Alert from "sweetalert-react";
import Loading from "../../../components/Loading";
import * as Http from "../../../http";
import * as Business from "../../../utils/business";
import IrrbbReportChild from "./IrrbbReportChild";

const dicSearchOptions = {
  report_date: "Report Date",
  file_name: "Report Name",
  approval_by: "Approver",
};

class ReportTable extends Component {
  state = {
    searchOption: "report_date",
    searchValue: "",
    items: [],
    loading: true,
  };

  batchWillDelete = null;

  componentDidMount() {
    const hash = window.location.hash;
    const qIdx = hash.indexOf("?");
    this.autoOpenReport =
      qIdx !== -1
        ? new URLSearchParams(hash.slice(qIdx)).get("reportName")
        : null;
    this.reportChildRefs = {};
    this.getListFile();
  }

  getListFile = () => {
    Http.getListBatch(Business.COMPONENT.IRRBB).then((data) => {
      if (data && data.Success) {
        let listData = data.Data.filter((e) => e && e.file_name.startsWith("IRRBB_"));
        listData.forEach((e) => { e.timestamp = new Date(e.upload_time || e.approval_date).getTime(); });
        listData = listData.sort((a, b) => b.timestamp - a.timestamp);
        this.setState({ items: listData, loading: false });
      }
    });
  };

  search = () => {
    const objSearch = {
      report_date: this.state.searchOption === "report_date" ? this.state.searchValue : null,
      file_name: this.state.searchOption === "file_name" ? this.state.searchValue : null,
      approval_by: this.state.searchOption === "approval_by" ? this.state.searchValue : null,
    };
    Http.getListBatch(Business.COMPONENT.IRRBB, objSearch).then((data) => {
      if (data && data.Success) {
        let listData = data.Data.filter((e) => e && e.file_name.startsWith("IRRBB_"));
        listData.forEach((e) => { e.timestamp = new Date(e.upload_time || e.approval_date).getTime(); });
        listData = listData.sort((a, b) => b.timestamp - a.timestamp);
        this.setState({ items: listData, loading: false });
      }
    });
  };

  deleteListItems = () => {
    Http.deleteBatch(Business.COMPONENT.IRRBB, this.batchWillDelete).then((res) => {
      if (res.Success) this.getListFile();
    });
    this.batchWillDelete = null;
  };

  onDelete = (reportName) => {
    this.batchWillDelete = reportName;
    this.setState({ showDeleteAlert: true });
  };

  render() {
    if (this.state.loading)
      return (
        <div style={{ height: Business.getHeightContent() }}>
          <Loading size="small" />
        </div>
      );

    return (
      <div className="card">
        <div className="header" style={{ marginBottom: "10px" }}>
          <h4 className="title">Report list</h4>
        </div>
        <div className="content table-responsive table-full-width">
          <div style={{ display: "flex", alignItems: "center", marginBottom: "20px", gap: "8px" }}>
            <div style={{ display: "inline", flexShrink: 0 }}>
              <DropdownButton title={dicSearchOptions[this.state.searchOption]} bsSize="small" id="irrbb-report-dropdown">
                <MenuItem onSelect={(k) => this.setState({ searchOption: k })} eventKey="approval_by">Approver</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(k) => this.setState({ searchOption: k })} eventKey="file_name">Report Name</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(k) => this.setState({ searchOption: k })} eventKey="report_date">Report Date</MenuItem>
                <MenuItem divider />
              </DropdownButton>
            </div>
            <div style={{ display: "flex", alignItems: "center", flex: 1, gap: "8px" }}>
              <input type="text" style={{ height: "30px", flex: 1 }} className="form-control" onChange={(e) => this.setState({ searchValue: e.target.value })} />
              <button type="button" className="btn btn-primary" style={{ backgroundColor: "#FFE600", borderColor: "#7F7E82", color: "#333", height: "30px", padding: "0 12px" }} onClick={this.search}>
                Search
              </button>
            </div>
          </div>
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                  <th>Report Date</th>
                  <th>Report Name</th>
                  <th>Uploader</th>
                  <th>Upload Time</th>
                  <th>Approver</th>
                  <th>Approval Time</th>
                  <th></th>
                </tr>
            </thead>
            <tbody>
              {this.state.items.map((item) => (
                <tr key={item.file_name + item.report_date}>
                  <td>{Business.convertToDate(item.report_date)}</td>
                  <td>
                      <IrrbbReportChild
                        report={item}
                        ref={(r) => {
                          if (r) this.reportChildRefs[item.file_name] = r;
                        }}
                      />
                    </td>
                  <td>{item.upload_by}</td>
                  <td>{Business.convertToFullDate(item.upload_time || item.upload_date)}</td>
                  <td>{item.approval_by}</td>
                  <td>{Business.convertToFullDate(item.approval_time || item.approval_date)}</td>
                  <td className="text-right">
                    {Business.isHasRole([Business.ROLE_DEFINE_MAP.ICAAP_DELETE_REPORT]) && (
                      <a className="btn btn-info btn-simple btn-xs" onClick={() => this.onDelete(item.file_name)}>
                        <i style={{ fontSize: 20, color: "red" }} className="pe-7s-trash"></i>
                      </a>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Alert
          title="Are you sure?"
          show={this.state.showDeleteAlert}
          text="You will not be able to recover this report!"
          showCancelButton
          onConfirm={() => { this.setState({ showDeleteAlert: false }); this.deleteListItems(); }}
          onCancel={() => { this.setState({ showDeleteAlert: false }); this.batchWillDelete = null; }}
        />
      </div>
    );
  }
}

export default class ReportList extends Component {
  render() {
    return (
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <ReportTable />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/IRRBB/Reports/ReportList.js